module.exports = __webpack_public_path__ + "static/media/filter-icon.3fb51e47.svg";